import { render, staticRenderFns } from "./calendarbirthday.vue?vue&type=template&id=c5cff7ac&"
import script from "./calendarbirthday.js?vue&type=script&lang=js&"
export * from "./calendarbirthday.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5cff7ac')) {
      api.createRecord('c5cff7ac', component.options)
    } else {
      api.reload('c5cff7ac', component.options)
    }
    module.hot.accept("./calendarbirthday.vue?vue&type=template&id=c5cff7ac&", function () {
      api.rerender('c5cff7ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/calendar/calendarbirthday.vue"
export default component.exports